import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import { actions } from 'modules/automations/store/collections/actions'
import type { Action } from 'modules/automations/store/models/Action'

interface Props {
  actionId: number
  onClose: () => void
}

const DeleteActionModal = ({ actionId, onClose }: Props) => {
  const action = React.useMemo<Action>(() => {
    const action = actions.find({
      id: actionId,
    })

    if (!action) throw new Error(`Missing action with id: ${actionId}`)

    return action
  }, [actionId])

  const onSubmit = async (closePortal: ClosePortalFn) => {
    if (!action) return

    const { success } = await asyncAction(() => action.destroy())

    if (success) {
      closePortal()
      actions.fetch()
    }
  }

  return (
    <Modal
      illustration="delete-cross"
      title={i18n.t('automations.actions.delete.title')}
      description={i18n.t('automations.actions.delete.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button type="negative" submit>
          {i18n.t('common.destroy')}
        </Button>
      }
    />
  )
}

export default DeleteActionModal
